import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  ModalCloseButton,
  useToast,
} from '@chakra-ui/react';
import { createFlow, updateFlow } from '../api/flow'; // API fonksiyonları

const FlowSaveModal = ({
  isOpen,
  onClose,
  initialFlowName = '',
  flowId,
  onUpdateSuccess,
  droppedItems, // Parent bileşenden gelen droppedItems
}) => {
  const [flowName, setFlowName] = useState('');
  const toast = useToast();

  // Modal açıldığında varsayılan isim ayarla
  useEffect(() => {
    if (isOpen) {
      setFlowName(initialFlowName || '');
    }
  }, [isOpen, initialFlowName]);

  const handleSave = async () => {
    if (!flowName.trim()) {
      toast({
        title: 'Flow Name Required',
        description: 'Please enter a valid flow name.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const flowData = {
      name: flowName,
      items: droppedItems.map(item => {
        const base = {
          id: item.id,
          toolboxId: item.toolboxId,
          position: { X: item.x, Y: item.y },
          rotation: item.rotation || 0,
          scale: item.scale || 100,
          textValue: item.textValue || '',
          tagId: item.tagInfo?.registerId || null,
          tag1Id: item.tagInfo1?.registerId || null,
          width: item.width ?? 50,
          height: item.height ?? 50,
          linkedFlowId: item.linkedFlowId || null,
          linkedFlowName: item.linkedFlowName || null,
        };

        if (item.toolboxId === '200') {
          return {
            ...base,
            fontSize: item.fontSize ?? 14,
            textColor: item.textColor ?? '#000000',
            backgroundColor: item.backgroundColor ?? '#ffffff',
            borderColor: item.borderColor ?? '#000000',
            isBold: item.isBold ?? false,
            isItalic: item.isItalic ?? false,
          };
        }

        return base;
      }),
    };

    try {
      if (flowId) {
        // Update işlemi
        await updateFlow(flowId, flowData);
        toast({
          title: 'Flow Updated',
          description: 'Your flow has been updated successfully.',
          status: 'success',
          duration: 1500,
          isClosable: true,
        });
      } else {
        // Yeni flow oluşturma
        await createFlow(flowData);
        toast({
          title: 'Flow Created',
          description: 'Your flow has been saved successfully.',
          status: 'success',
          duration: 1500,
          isClosable: true,
        });
      }
      // Yeni tab olarak açıldığı için doğrudan kapat
      setTimeout(() => window.close(), 1000);
    } catch (error) {
      console.error('Error saving flow:', error);
      toast({
        title: 'Error',
        description:
          error.response?.data?.message ||
          'An error occurred while saving the flow.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{flowId ? 'Edit Flow' : 'Save Flow'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Enter flow name"
            value={flowName}
            onChange={e => setFlowName(e.target.value)}
            autoFocus
          />
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" ml={3} onClick={handleSave}>
            {flowId ? 'Update' : 'Save'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FlowSaveModal;
